<template>
  <div :class="getItemTableContainerClass">
    <ItemTable
      ref="itemTable"
      :boundItemsUrl="boundItemsUrl"
      :columns="columns"
      :hasSelectColumn="true"
      :inDetailsAsidePanel="true"
      :itemType="itemType"
      :linkText="systemGroupLinkText"
      :route="route"
      :selectionItemText="systemGroupItemText"
      :showBound="true"
      :showSearchForm="true"
    />
  </div>
</template>
<script>
import {
  ItemTableConsts,
  ItemTypeConsts,
  StoreModuleMap,
} from 'client/util/Constants';
import { mapGetters } from 'vuex';
import AsidePanelChildComponentPropsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentPropsMixin';
import DeviceCount from 'client/components/ItemTable/BodyComponents/DeviceCount.vue';
import GroupItemTableColumns from 'client/components/ItemTable/GroupItemTableColumns';
import ItemTable from 'client/components/ItemTable/ItemTable.vue';
import ItemTableComputedMixin from 'client/components/ItemTable/mixins/ItemTableComputedMixin';
import ItemTableMethodsMixin from 'client/components/ItemTable/mixins/ItemTableMethodsMixin';
import ItemTablePropsMixin from 'client/components/ItemTable/mixins/ItemTablePropsMixin';
import ItemType from 'client/util/Constants/ItemType';
import SystemGroupSudoStatus from 'client/components/ItemTable/BodyComponents/SystemGroupSudoStatus.vue';

const { columnTypes } = ItemTableConsts;
const { DeviceItemType, DeviceGroupItemType } = ItemType;
const deviceItem = new DeviceItemType();
const deviceGroupItem = new DeviceGroupItemType();
const systemGroupCollection = StoreModuleMap[ItemTypeConsts.systemGroup];

export default {
  name: 'SystemGroupItemTable',

  components: {
    ItemTable,
  },

  mixins: [
    AsidePanelChildComponentPropsMixin,
    ItemTableComputedMixin,
    ItemTableMethodsMixin,
    ItemTablePropsMixin,
  ],

  props: {
    parent: {
      type: Object,
      default: () => {},
    },
    showNewWorkflow: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      itemType: ItemTypeConsts.deviceGroup,
    };
  },

  computed: {
    ...mapGetters(systemGroupCollection, {
      getSudoersToUpdate: 'getSudoersToUpdate',
    }),

    columns() {
      const columns = [
        {
          bodyComponent: 'GroupTypeIcon',
          classNames: {
            body: [columnTypes.iconColumn],
            heading: [columnTypes.iconColumn],
          },
          headingText: 'Type',
          sortBy: 'type',
        },
        {
          bodyComponent: 'ItemName',
          bodyComponentProps: {
            titleField: 'name',
            subtitleFunction: this.itemNameSubtitleValue,
          },
          headingText: 'Group',
          sortBy: 'name',
        },
      ];

      if (this.showNewWorkflow) {
        columns.push({
          bodyComponent: SystemGroupSudoStatus,
          bodyComponentProps: {
            parent: this.parent,
            showNewWorkflow: this.showNewWorkflow,
          },
          headingText: 'Permissions',
        });
      }
      columns.push({
        bodyComponent: DeviceCount,
        bodyComponentProps: {
        },
        headingText: 'Number of Devices',
      });
      columns.push(GroupItemTableColumns.defaultDeviceGroup);

      return columns;
    },

    route() {
      return deviceGroupItem.route;
    },

    systemGroupItemText() {
      return {
        label: 'bound',
        plural: deviceGroupItem.titlePlural,
        singular: deviceGroupItem.title,
      };
    },

    systemGroupLinkText() {
      return deviceGroupItem.titlePlural;
    },
  },

  methods: {
    itemNameSubtitleValue() {
      return `Group of ${deviceItem.titlePlural}`;
    },
  },
};
</script>
